import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { isAdmin } from '@/utils/auth'

export const Route = createFileRoute('/_auth/settings/tickets')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()
  const currentTab = location.pathname.split('/').pop()
  const tabs = isAdmin()
    ? [
        {
          label: 'Loại ticket',
          value: 'ticket-type',
        },
        {
          label: 'Thuộc tính',
          value: 'attributes',
        },
        {
          label: 'Mẫu trả lời',
          value: 'template',
        },
        {
          label: 'Mức ưu tiên',
          value: 'priority',
        },
        {
          label: 'Dịch vụ',
          value: 'service',
        },
        {
          label: 'SmartView',
          value: 'view',
        },
      ]
    : [
        {
          label: 'SmartView',
          value: 'view',
        },
      ]

  const handleChange = (value) => {
    navigate({
      to: `/settings/tickets/${value}`,
    })
  }
  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-hidden">
      <Tabs
        value={currentTab || 'ticket-type'}
        onValueChange={handleChange}
        className="w-full"
      >
        <TabsList className="mb-2">
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <Outlet />
    </div>
  )
}
